import { makeAutoObservable } from 'mobx';

export type ThemePreference = 'light' | 'dark' | 'system';

const STORAGE_KEY = 'theme-preference';

export class ThemeStore {
  preference: ThemePreference = 'system';

  constructor() {
    makeAutoObservable(this);
    this.loadFromStorage();
  }

  private loadFromStorage() {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark' || saved === 'system') {
      this.preference = saved;
    }
  }

  setPreference(pref: ThemePreference) {
    this.preference = pref;
    localStorage.setItem(STORAGE_KEY, pref);
  }
}
